import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  width: 50%;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const SuccessMessage = styled.div`
  color: #155724;
  background: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 16px;
  border-radius: 4px;
  margin-top: 10px;
  position: relative;
  font-weight: 500;
`;

export const ErrorMessage = styled.div`
  color: #721c24;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 12px 16px;
  border-radius: 4px;
  margin-top: 10px;
  position: relative;
  font-weight: 500;
`;
